import { render, staticRenderFns } from "./DeactivateReasonFraud.vue?vue&type=template&id=eb7054cc&"
import script from "./DeactivateReasonFraud.vue?vue&type=script&lang=ts&"
export * from "./DeactivateReasonFraud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports